// extracted by mini-css-extract-plugin
export default {"NotFound":"styles_NotFound__GB28Z","button":"styles_button__bEn8z"};